function getUrlLogo(empresa: string, nombreArchivo: string) {
  return `https://storage.googleapis.com/${process.env.REACT_APP_BUCKET_NAME}/Empresas/${empresa}/${nombreArchivo}`;
}

export default getUrlLogo;